function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var baseStyle = {
  table: {
    fontVariantNumeric: 'lining-nums tabular-nums',
    borderCollapse: 'collapse',
    borderSpacing: '0 8px'
  }
};
var variantSimple = () => {
  return {
    table: {
      borderWidth: '1px',
      borderColor: 'grey.300'
    },
    th: {
      background: 'blue.50',
      borderBottom: '1px solid',
      borderColor: 'grey.300',
      py: 0,
      // styling wrapper component in tq
      '.tqc-datatable__th-content': {
        color: 'blue.275',
        background: 'blue.50',
        borderBottom: '1px solid',
        borderColor: 'grey.300',
        fontSize: '16px',
        letterSpacing: 0,
        py: 4
      }
    },
    td: {
      py: 0,
      borderBottom: '1px solid',
      borderColor: 'grey.300',
      // styling wrapper component in tq
      '&.tqc-datatable__td': {
        py: 4,
        color: 'black',
        borderBottom: '1px solid',
        borderColor: 'grey.300',
        fontSize: '16px'
      }
    }
  };
};
var variantStripe = () => {
  return _objectSpread(_objectSpread({}, variantSimple()), {}, {
    tbody: {
      tr: {
        '&:nth-of-type(odd)': {
          'th, td': {
            borderBottomWidth: '1px',
            borderColor: 'grey.300'
          },
          td: {
            background: 'grey.200'
          }
        }
      }
    },
    tfoot: {
      tr: {
        '&:last-of-type': {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  });
};
var sizes = {
  sm: {
    th: {
      px: '4',
      py: 0,
      fontSize: '14px',
      lineHeight: '20px',
      height: '2rem'
    },
    td: {
      px: '4',
      py: 0,
      fontSize: '14px',
      lineHeight: '20px',
      height: '1.75rem'
    },
    caption: {
      px: '4',
      py: '2',
      fontSize: 'xs'
    }
  },
  md: {
    th: {
      px: '6',
      py: 0,
      fontSize: '14px',
      lineHeight: '20px',
      height: '2.5rem'
    },
    td: {
      px: '6',
      py: 0,
      fontSize: '14px',
      lineHeight: '20px',
      height: '2.5rem'
    },
    caption: {
      px: '6',
      py: '2',
      fontSize: '14px'
    }
  },
  lg: {
    th: {
      px: '8',
      py: 0,
      fontSize: '16px',
      lineHeight: '24px',
      height: '3.5rem'
    },
    td: {
      px: '8',
      py: 0,
      fontSize: '16px',
      lineHeight: '24px',
      height: '3.5rem'
    },
    caption: {
      px: '6',
      py: '2',
      fontSize: '16px'
    }
  }
};
var variants = {
  simple: variantSimple,
  striped: variantStripe,
  unstyled: {}
};
export var Table = {
  baseStyle,
  sizes,
  variants
};